import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Layout } from '../common/Layout';
import { Dashboard } from '../dashboard/Dashboard';
import { Landing } from '../landing/Landing';

export const Home = () => {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-b-2 border-primary-600" />
          <p className="mt-4 text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (user) {
    return (
      <Layout>
        <Dashboard />
      </Layout>
    );
  }

  return <Landing />;
};
